<template>
  <v-snackbar
    v-model="value"
  >
    {{ cfg.message }}
  </v-snackbar>
</template>

<script>

const _cfg = {
  message: '',
  bottom: true
}

export default {
  data: function () {
    return {
      value: false,
      cfg: { ..._cfg }
    }
  },
  methods: {
    show: function (props) {
      this.cfg = { ..._cfg, ...props }
      this.value = true
      return this
    }
  }
}
</script>
